import { render, staticRenderFns } from "./DepartmentListItem.vue?vue&type=template&id=925acca4&"
import script from "./DepartmentListItem.vue?vue&type=script&lang=js&"
export * from "./DepartmentListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepartmentListItem.vue"
export default component.exports